import './App.css';
import Home from './screens/Home/Home';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <Home />
  );
}

export default App;
